import React, {Component} from 'react';

export default class Header extends Component {
    render() {
        return (
            <div className="center">
                <h1>
                    DEMETRIUS WILLIAMSON
                </h1>
                <hr className="name-divider hr"/>
            </div>
        );
    }
}
